import { observer } from 'mobx-react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { TodoTaskCard } from '../components/cards/todoTaskCard';
import { useEffect, useState } from 'react';
import { useLoanStore } from '@roc/feature-loans';
import { isAgreedLoan, isFundedLoan, LoanProcess } from '@roc/feature-utils';
import { DocumentForms, useDocumentStore } from '@roc/feature-documents';
import { ClosingStatusStepper } from '../components/loanDetailsStepper';
import { Paper, PaperBorderType } from '@roc/ui';
import { LoanKeyInformationCard } from '../components/cards/loanKeyInformationCard';
import { NotFullySubmittedAlert } from '../components/cards/notFullySubmittedAlert';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    '@media (max-width: 992px)': {
      marginLeft: '-6px',
    },
  },
  paper: {
    border: '1px solid #d5d5d5 !important',
    borderRadius: 16,
    overflow: 'hidden',
  },
}));

export const ToDosTasksTab = observer(() => {
  const { documentStore } = useDocumentStore();
  const { loanStore } = useLoanStore();
  const { loanDetails } = loanStore;
  const loanId = loanDetails?.loanId;
  const loanProcess = LoanProcess.TODOS;
  const classes = useStyles();

  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    documentStore.loanTodosStore.setShowOnlyPending(false);
    documentStore.loanTodosStore.setPrioritiesFilter([]);
    setInitialized(true);
  }, []);

  useEffect(() => {
    if (loanStore?.doAutoRefresh && !loanStore?.autoRefreshOn) {
      loanStore.setAutoRefreshOn(true);
      console.log('Will do auto refresh');
      setTimeout(function () {
        window.location.reload();
      }, 180000);
    }
  }, [loanStore?.doAutoRefresh]);

  const todos = documentStore.loanTodosStore.todosByLoanProcess[loanProcess] ?? []

  return (
    <>
      <>
        <Grid item xs={12}>
          <Paper borderType={PaperBorderType.SOLID_BORDER} className={classes.paper}>
            <ClosingStatusStepper />
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <LoanKeyInformationCard loanStore={loanStore} />
        </Grid>
      </>
      {
        initialized &&
        <Grid item xs={12} className={classes.container}>
          {loanDetails?.fullySubmitted ?
            <TodoTaskCard
              loanProcess={loanProcess}
              showFilter
              showSectionActions={true}
              showFileName={true}
              showDownloadAll
              todos={todos}
              showActions={true}
              loanId={loanId}
              showPriorityColumn={true}
              showAssigneeColumn={true}
            />
            :
            <NotFullySubmittedAlert />
          }
        </Grid>
      }
      <DocumentForms loanId={loanDetails.loanId} />
    </>
  );
});
